
import axiosInstance from './axiosConfig';

const userService = {
  // Get all products with pagination and filters
  getUsers: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/user/getUsers', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },
}

export default userService